import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Trash2, ChevronRight, Mic, Brain, Code2 } from "lucide-react";
import { toast } from "sonner";

const MODE_ICON = { live: Mic, mock: Brain, coding: Code2 };

export default function SessionHistory() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSessions = () => {
    api.get("/sessions").then((r) => setSessions(r.data)).finally(() => setLoading(false));
  };
  useEffect(fetchSessions, []);

  const remove = async (id) => {
    await api.delete(`/sessions/${id}`);
    toast.success("Session deleted");
    fetchSessions();
  };

  return (
    <div className="px-10 py-10">
      <h1 className="font-display text-5xl font-black tracking-tighter mb-2">Session History</h1>
      <p className="text-neutral-500 mb-10">Review your past interview sessions.</p>
      {loading ? (
        <div className="text-neutral-500 text-sm">Loading…</div>
      ) : sessions.length === 0 ? (
        <div className="border border-dashed border-white/10 p-12 text-center text-neutral-500 text-sm">
          No sessions yet. <Link to="/app" className="text-[#D3FF24] hover:underline">Start your first interview</Link>
        </div>
      ) : (
        <div className="grid gap-px bg-white/10 border border-white/10" data-testid="sessions-list">
          {sessions.map((s) => {
            const Icon = MODE_ICON[s.mode] || Mic;
            return (
              <div key={s.id} className="bg-[#0A0A0A] hover:bg-[#0F0F0F] p-5 flex items-center gap-5 transition">
                <Icon className="w-5 h-5 text-[#D3FF24]" strokeWidth={1.5} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3">
                    <span className="font-display font-semibold">{s.position}</span>
                    <span className="text-neutral-600">@</span>
                    <span className="text-neutral-400">{s.company}</span>
                  </div>
                  <div className="text-[10px] uppercase tracking-widest text-neutral-500 mt-1 flex items-center gap-3">
                    <span>{s.mode}</span>·<span>{s.scenario}</span>·<span>{new Date(s.created_at).toLocaleDateString()}</span>
                    <span className={`px-2 py-0.5 ${s.status==="active" ? "bg-[#D3FF24]/20 text-[#D3FF24]" : "bg-white/5 text-neutral-500"}`}>{s.status}</span>
                  </div>
                </div>
                <button onClick={() => remove(s.id)} data-testid={`delete-${s.id}`} className="text-neutral-600 hover:text-[#FF3B30] p-2">
                  <Trash2 className="w-4 h-4" />
                </button>
                <Link to={`/app/sessions/${s.id}`} data-testid={`open-${s.id}`} className="text-neutral-400 hover:text-white p-2">
                  <ChevronRight className="w-5 h-5" />
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
